export default __webpack_public_path__ + "static/media/big1.7fc7bcf1.jpg";